function buildFlightEvents (newFlights, oldFlights, cartId) {
  if (newFlights && !oldFlights) {
    return [addEvent(newFlights, cartId)]
  }

  if (!newFlights && oldFlights) {
    return [removeEvent(oldFlights, cartId)]
  }
  return []
}

function addEvent (addedFlights, cartId) {
  return {
    event: 'addToCart',
    cart_lines: cartLinesFor(addedFlights, cartId),
  }
}

function removeEvent (removedFlights, cartId) {
  return {
    event: 'removeFromCart',
    cart_lines: cartLinesFor(removedFlights, cartId),
  }
}

function cartLinesFor (flights, cartId) {
  return [{
    cart_id: cartId,
    value: `${flights.total}`,
    product: {
      id: `flights`,
      name: `flights`,
      category: 'Extras/Flights',
      quantity: '1',
      value: `${flights.total}`,
    },
  }]
}

export default {
  eventsFor: (oldState, newState) => {
    if (oldState && oldState.priceBreakdown && newState && newState.priceBreakdown) {
      return buildFlightEvents(newState.priceBreakdown.flights, oldState.priceBreakdown.flights, newState.cart.cartId)
      //      const flightEvents = buildFlightEvents(newState.priceBreakdown.flights?flightsFrom(newState.priceBreakdown.flights.legs):[], oldState.priceBreakdown.flights?flightsFrom(oldState.priceBreakdown.flights.legs):[], newState.cart.cartId)
    }

    return []
  },
  cartLinesFor: (currentState) => {
    return (currentState.priceBreakdown && currentState.priceBreakdown.flights) ? cartLinesFor(currentState.priceBreakdown.flights, currentState.cart.cartId) : []
  },
//    return cartLinesForFlights((currentState.priceBreakdown && currentState.priceBreakdown.flights) ? flightsFrom(currentState.priceBreakdown.flights.legs) : [], currentState.priceBreakdown, currentState.cart.cartId)
}
